import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { confirmAddAccount, addFormChange } from "../../../../domain/validation/validationActions";
import { setAccountToEdit } from "../../../../domain/accts/acctsActions";
import { openModal, closeModal } from "../../../../domain/ui/uiActions";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage, defineMessages } from "react-intl";
import PhoneLink from "../../../presentational/PhoneLink";
import AddAccountForm from "./AddAccountForm/AddAccountForm";
import { resetMessages } from "../../../../domain/misc/miscActions";
import getUniqueDisclaimers from "./getUniqueDisclaimers";
import { AUTO_ADDED_PAYABLE_MESSAGE_DOMAIN } from "assets/scripts/domain/accts/acctsReducer";
import AccountList from "./AccountList/AccountList";
import groupAccounts from "./groupAccounts";
import ImportantInformation from "./ImportantInformation/ImportantInformation";
import MyWayForwardSummary from "./MyWayForwardSummary/MyWayForwardSummary-CapOne";
import track from "react-tracking";
const messages = defineMessages({
    liveHeader: {
        id: "dashboard.accounts.live.header",
        defaultMessage: "My Accounts"
    },
    deceasedHeader: {
        id: "dashboard.accounts.deceased.header",
        defaultMessage: "Estate Accounts"
    },
    autoAddedPayable: {
        id: "dashboard.autoAddedPayable",
        defaultMessage: "Additional accounts have been automatically identified and associated with your profile."
    }
});
class Dashboard extends Component {
    render() {
        const { disclaimers, disclaimerIdMap } = getUniqueDisclaimers(this.props.accts.data, this.props.locale);
        const acctsLoaded = !this.props.acctsIsLoading && !this.props.acctsError;
        let live = [];
        let deceased = [];
        if (acctsLoaded) {
            ({ live, deceased } = groupAccounts(this.props.accts.data || [], this.props.locale));
        }
        return (<div className="wrapper">
				<h1 className="u-isVisuallyHidden js-pageHeader">
					<FormattedMessage id="dashboard.header" defaultMessage="Dashboard"/>
				</h1>
				<StatusMessage isError={!this.props.authIsSuccess} isSuccess={this.props.authIsSuccess} isActive={this.props.authIsSuccess !== null ? true : false} customMessage={this.props.authIsSuccess ?
            StatusMessages.AUTH.SUCCESS_MESSAGE_PASSWORD_CHANGED :
            ""} domain="auth" autoReset={false}/>
				<StatusMessage isError={!this.props.contactIsSuccess} isSuccess={this.props.contactIsSuccess} isActive={this.props.contactIsSuccess !== null ? true : false} customMessage={this.props.contactIsSuccess ?
            StatusMessages.CONTACT.SUCCESS_MESSAGE_CONTACT :
            ""} domain="contact" autoReset={false}/>
				{!acctsLoaded && (<div className="vr vr_x4">
						<h3 className="hdg">
							<FormattedMessage id="dashboard.accounts.header" defaultMessage="Accounts"/>
						</h3>
					</div>)}
				<StatusMessage isLoad isActive={this.props.acctsIsLoading ? true : false}/>
				<StatusMessage isError isActive={this.props.acctsError ? true : false} error={this.props.acctsError ? this.props.acctsError : null} customMessage={StatusMessages.ACCTS.INTRO_ACCTS} domain="accts" willPersist/>
				<StatusMessage isActive={this.props.accts.autoAddedPayable} customMessage={messages.autoAddedPayable} domain={AUTO_ADDED_PAYABLE_MESSAGE_DOMAIN} isSuccess willPersist/>
				{live.length > 0 && (<AccountList accts={live} header={messages.liveHeader} deceased={false} openModal={this.props.openModal} setAccountToEdit={this.props.setAccountToEdit} disclaimerIdMap={disclaimerIdMap} showDisclaimerLinks/>)}
				{deceased.length > 0 && (<AccountList accts={deceased} header={messages.deceasedHeader} deceased openModal={this.props.openModal} setAccountToEdit={this.props.setAccountToEdit} disclaimerIdMap={disclaimerIdMap} showDisclaimerLinks/>)}

				{process.env.CLIENT !== "CapOne" && (<ImportantInformation disclaimers={disclaimers} disclaimerIdMap={disclaimerIdMap}/>)}

				<div className="vr vr_x4">
					<h2 className="hdg">
						<FormattedMessage id="dashboard.addaccount.header" defaultMessage="Add Additional Accounts"/>
					</h2>
				</div>
				<div className="vr vr_x4">
					<div className="text">
						<p>
							<FormattedMessage id="dashboard.addaccount" defaultMessage={"If you have received another letter from DCM Services regarding a matter for which "
            + "you have the authority to act on behalf of the estate, you may add the account here. "
            + "Please note – a reference/file number and PIN are required in order to view "
            + "the account online. If you do not have a PIN, please call DCM Services "
            + "at the phone number above."} values={{
            phone: <PhoneLink />
        }}/>
						</p>
					</div>
				</div>
				<StatusMessage isSuccess={this.props.validationIsSuccess} isActive={this.props.validationIsSuccess ? true : false} customMessage={StatusMessages.VALIDATION.SUCCESS_MESSAGE_ADD} domain="validation"/>

				<AddAccountForm {...this.props}/>

				{process.env.CLIENT === "CapOne" && (<Fragment>
						<ImportantInformation disclaimers={disclaimers} disclaimerIdMap={disclaimerIdMap}/>
						<MyWayForwardSummary />
					</Fragment>)}
			</div>);
    }
    componentWillUnmount() {
        /* If the user leaves this page, make sure the modal is closed */
        if (!this.props.background) {
            this.props.closeModal({ modalId: "", triggerId: "" });
            this.props.resetMessages("auth");
            this.props.resetMessages("contact");
        }
    }
}
const mapStateToProps = (state) => ({
    accts: state.accts,
    acctsError: state.accts.error,
    acctsIsLoading: state.accts.isLoading,
    authFieldErrors: state.auth.fieldErrors,
    authIsSuccess: state.auth.isSuccess,
    contactFieldErrors: state.contact.fieldErrors,
    contactIsSuccess: state.contact.isSuccess,
    validationError: state.validation.error,
    validationFieldErrors: state.validation.fieldErrors,
    validationIsLoading: state.validation.isLoading,
    validationIsSuccess: state.validation.isSuccess,
    addForm: state.validation.addForm,
    locale: state.i18n.locale
});
const bindActionsToProps = {
    closeModal,
    confirmAddAccount,
    addFormChange,
    openModal,
    setAccountToEdit,
    resetMessages
};
export const dashboardConnect = connect(mapStateToProps, bindActionsToProps);
export default track({ page: "Dashboard" }, { dispatchOnMount: true })(dashboardConnect(Dashboard));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/Dashboard.tsx